module.exports = __webpack_public_path__ + "img/article5.5148eebe.jpg";